<template>
  <DemandeContent
    class="dispositif"
    :navigate-to-location
    :key
  ></DemandeContent>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'
  import { DemandeContent } from './shared'
  import type { NavigateToDemande, WithNavigateToLocation } from '@/router/navigateTo'

  const props = defineProps<WithNavigateToLocation<NavigateToDemande>>()

  const key = computed(() => Object.values(props.navigateToLocation).join('-'))
</script>
<style scoped lang="less">
  .dispositif {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: @spacing-10;
    overflow: hidden;
  }
</style>
<style lang="less">
  @import './shared/ListeDispositifElements.less';

  .help-btn {
    border-radius: 50%;
    transform: scale(0.5) translateX(-10px);
    transition: transform 0.3s;
    min-width: 40px;
  }

  .help-btn :deep(span) {
    font-size: 1.4rem;
  }

  .help-btn:hover {
    transform: scale(0.8) translateX(-4px);
  }
</style>
